// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .loaderContainer{
  margin: 0 auto;
  width: 100%;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.loadText{
  display: flex;
  color: var(--black-color);
}

.loadText::after{
  content: '.';
  margin-left: 5px;
  animation: 3s completaLoadingText ease infinite;
}

.loader {
    transform: rotateZ(45deg);
    perspective: 1000px;
    border-radius: 50%;
    width: 48px;
    height: 48px;
    color: #000000;
  }
  .loader:before,
  .loader:after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: inherit;
      height: inherit;
      border-radius: 50%;
      transform: rotateX(70deg);
      animation: 1s spin linear infinite;
    }
    .loader:after {
      color: var(--azulthink);
      transform: rotateY(70deg);
      animation-delay: .4s;
    }


    @keyframes rotate {
      0% {
        transform: translate(-50%, -50%) rotateZ(0deg);
      }
      100% {
        transform: translate(-50%, -50%) rotateZ(360deg);
      }
    }
  
    @keyframes rotateccw {
      0% {
        transform: translate(-50%, -50%) rotate(0deg);
      }
      100% {
        transform: translate(-50%, -50%) rotate(-360deg);
      }
    }
  
    @keyframes spin {
      0%,
      100% {
        box-shadow: .2em 0px 0 0px currentcolor;
      }
      12% {
        box-shadow: .2em .2em 0 0 currentcolor;
      }
      25% {
        box-shadow: 0 .2em 0 0px currentcolor;
      }
      37% {
        box-shadow: -.2em .2em 0 0 currentcolor;
      }
      50% {
        box-shadow: -.2em 0 0 0 currentcolor;
      }
      62% {
        box-shadow: -.2em -.2em 0 0 currentcolor;
      }
      75% {
        box-shadow: 0px -.2em 0 0 currentcolor;
      }
      87% {
        box-shadow: .2em -.2em 0 0 currentcolor;
      }
    }

    @keyframes completaLoadingText {
      0% {
        content: '';
      }
      33% {
        content: '.';
      }
      66% {
        content: '..';
      }
      100% {
        content: '...';
      }
    }
  `, "",{"version":3,"sources":["webpack://./src/assets/css/loaderEspiral.css"],"names":[],"mappings":"CAAC;EACC,cAAc;EACd,WAAW;EACX,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;EACA;;MAEI,WAAW;MACX,cAAc;MACd,kBAAkB;MAClB,MAAM;MACN,OAAO;MACP,cAAc;MACd,eAAe;MACf,kBAAkB;MAClB,yBAAyB;MACzB,kCAAkC;IACpC;IACA;MACE,uBAAuB;MACvB,yBAAyB;MACzB,oBAAoB;IACtB;;;IAGA;MACE;QACE,8CAA8C;MAChD;MACA;QACE,gDAAgD;MAClD;IACF;;IAEA;MACE;QACE,6CAA6C;MAC/C;MACA;QACE,gDAAgD;MAClD;IACF;;IAEA;MACE;;QAEE,uCAAuC;MACzC;MACA;QACE,sCAAsC;MACxC;MACA;QACE,qCAAqC;MACvC;MACA;QACE,uCAAuC;MACzC;MACA;QACE,oCAAoC;MACtC;MACA;QACE,wCAAwC;MAC1C;MACA;QACE,sCAAsC;MACxC;MACA;QACE,uCAAuC;MACzC;IACF;;IAEA;MACE;QACE,WAAW;MACb;MACA;QACE,YAAY;MACd;MACA;QACE,aAAa;MACf;MACA;QACE,cAAc;MAChB;IACF","sourcesContent":[" .loaderContainer{\r\n  margin: 0 auto;\r\n  width: 100%;\r\n  height: 400px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-direction: column;\r\n}\r\n\r\n.loadText{\r\n  display: flex;\r\n  color: var(--black-color);\r\n}\r\n\r\n.loadText::after{\r\n  content: '.';\r\n  margin-left: 5px;\r\n  animation: 3s completaLoadingText ease infinite;\r\n}\r\n\r\n.loader {\r\n    transform: rotateZ(45deg);\r\n    perspective: 1000px;\r\n    border-radius: 50%;\r\n    width: 48px;\r\n    height: 48px;\r\n    color: #000000;\r\n  }\r\n  .loader:before,\r\n  .loader:after {\r\n      content: '';\r\n      display: block;\r\n      position: absolute;\r\n      top: 0;\r\n      left: 0;\r\n      width: inherit;\r\n      height: inherit;\r\n      border-radius: 50%;\r\n      transform: rotateX(70deg);\r\n      animation: 1s spin linear infinite;\r\n    }\r\n    .loader:after {\r\n      color: var(--azulthink);\r\n      transform: rotateY(70deg);\r\n      animation-delay: .4s;\r\n    }\r\n\r\n\r\n    @keyframes rotate {\r\n      0% {\r\n        transform: translate(-50%, -50%) rotateZ(0deg);\r\n      }\r\n      100% {\r\n        transform: translate(-50%, -50%) rotateZ(360deg);\r\n      }\r\n    }\r\n  \r\n    @keyframes rotateccw {\r\n      0% {\r\n        transform: translate(-50%, -50%) rotate(0deg);\r\n      }\r\n      100% {\r\n        transform: translate(-50%, -50%) rotate(-360deg);\r\n      }\r\n    }\r\n  \r\n    @keyframes spin {\r\n      0%,\r\n      100% {\r\n        box-shadow: .2em 0px 0 0px currentcolor;\r\n      }\r\n      12% {\r\n        box-shadow: .2em .2em 0 0 currentcolor;\r\n      }\r\n      25% {\r\n        box-shadow: 0 .2em 0 0px currentcolor;\r\n      }\r\n      37% {\r\n        box-shadow: -.2em .2em 0 0 currentcolor;\r\n      }\r\n      50% {\r\n        box-shadow: -.2em 0 0 0 currentcolor;\r\n      }\r\n      62% {\r\n        box-shadow: -.2em -.2em 0 0 currentcolor;\r\n      }\r\n      75% {\r\n        box-shadow: 0px -.2em 0 0 currentcolor;\r\n      }\r\n      87% {\r\n        box-shadow: .2em -.2em 0 0 currentcolor;\r\n      }\r\n    }\r\n\r\n    @keyframes completaLoadingText {\r\n      0% {\r\n        content: '';\r\n      }\r\n      33% {\r\n        content: '.';\r\n      }\r\n      66% {\r\n        content: '..';\r\n      }\r\n      100% {\r\n        content: '...';\r\n      }\r\n    }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
